
import { Component, Vue } from 'vue-property-decorator';
import { AccountInfo } from '@airgap/beacon-sdk';
import Table from '@/components/Table.vue';
import { Module1Module } from '@/store/modules/module1';

@Component({
  components: {
    Table
  }
})
export default class Tips extends Vue {
  showModal = false;
  allowModalToBeClosed = false;
  modalTitle = 'Please Wait';
  modalParagraph = 'Transaction pending...'

  get account () : AccountInfo | undefined | null {
    return Module1Module.account;
  }

  possiblyCloseModal () : void {
    if (this.allowModalToBeClosed) {
      this.showModal = false;
      this.allowModalToBeClosed = false;
    }
  }

  async tip (tezos: number) : Promise<void> {
    try {
      this.showModal = true;
      this.allowModalToBeClosed = false;
      this.modalTitle = 'Sending Your Tip';
      this.modalParagraph = `Seriously, thank you.<br><br>Sending ${tezos}ꜩ...`;

      if (!Module1Module.account) {
        await Module1Module.Login();
      }

      const tx = await Module1Module.tezosToolkitInstance.wallet.transfer({
        to: 'tz1gp2XcTnpGxYcfYvyukB8c6B7iu3VRKp8B',
        amount: tezos
      });
      const op = await tx.send();

      this.showModal = true;
      this.allowModalToBeClosed = false;
      this.modalTitle = 'Confirming Your Tip';
      this.modalParagraph = 'Waiting for block confirmation...';

      await op.confirmation();

      this.showModal = true;
      this.allowModalToBeClosed = true;
      this.modalTitle = 'Cheers';
      this.modalParagraph = 'Thank you for tez yo!<br><br>You are a legend in my world.';
    } catch (error) {
      this.showModal = true;
      this.allowModalToBeClosed = true;
      this.modalTitle = 'Cancelled';
      this.modalParagraph = 'Thanks anyways!';
      console.log(error);
    }
  }
}
